import $ from 'jquery';

$(document).on("turbolinks:load", ()=>{
    $("#order_driver_ci").on("change", ({target})=>{
        completeDriverInfo(target.value)
    })
})

function completeDriverInfo(ci){
    $.ajax(`/orders/ci/last/${ci}.json`, {
        method: 'GET',
        success: (list)=>{
            if (list.length > 0){
                let order = list[0];
                $("#order_driver")[0].value = order.driver;
                $("#order_car_plate_number")[0].value = order.car_plate_number;
                $("#order_cart_number")[0].value = order.cart_number;
                $("#order_brand")[0].value = order.brand;
                $("#order_brand_type")[0].value = order.brand_type;
                $("#order_color")[0].value = order.color;
            }
        }
    })
}